import './components/TheToolbar/TheToolbar.js';
import './components/WPlayer/WPlayer.js';
import './components/LoadingIndicator/index.js';
import { player } from "./utils/player.js";
import { WPlayer } from './components/WPlayer/WPlayer.js';
import { loadingIndicator } from './stores/loadingIndicator.js';
import { eventEmitter } from './utils/eventEmitter/index.js';
import { profileStore } from "@/stores/profile";
import { initRouting } from "@/router";
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
   :host {
      background-color: var(--color-block);
      width: 100%;
      min-height: 100dvh;
      display: flex;
      flex-direction: column;
      max-height: 100dvh;
      color: white;
      padding-bottom: 60px;
    }
    
    *, :host {
      box-sizing: border-box;
    }
    
    .content-wrapper {
      flex-grow: 1;
      width: 100%;
      min-height: 0;
      overflow: auto;
      padding: 0 20px;
    }
    
    .content {
      max-width: 800px;
      width: 100%;
      margin: 0 auto;
      
      & * {
        width: 100%;
      }
    }
    
    .player {
      position: fixed;
      right: 0;
      left: 0;
      z-index: 10;
      bottom: 0;
    }
    
    loading-indicator {
      width: 100%;
    }
`);
export class TheApp extends HTMLElement {
    static tag = 'the-app';
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [styleSheet];
    }
    connectedCallback() {
        this.#initDOM();
        loadingIndicator.register(this.shadowRoot.querySelector('loading-indicator'));
        eventEmitter.on('current track change', () => {
            if (this.#isPlayerCreated || !player.currentTrack)
                return;
            this.#createPlayer();
        });
        this.#loadUserData()
            .then(() => {
            if (!('navigation' in window)) {
                import('@virtualstate/navigation').then(() => initRouting());
            }
            else {
                initRouting();
            }
            eventEmitter.on('auth status update', ({ LoggedIn }) => {
                if (!LoggedIn) {
                    this.shadowRoot.querySelector('w-player')?.remove();
                    player.reset();
                }
                else {
                    if (profileStore.profile.settings.canSaveActiveTrackState) {
                        this.#processPlayerState();
                    }
                }
                navigation.navigate('/');
            });
            this.#processPlayerState();
        });
    }
    #createPlayer() {
        const $player = new WPlayer({ track: player.currentTrack });
        $player.classList.add('player');
        eventEmitter.on('current track change', ({ currentTrack }) => {
            if (!currentTrack)
                return;
            $player.track = currentTrack;
        });
        this.shadowRoot.append($player);
    }
    #initDOM() {
        this.shadowRoot.innerHTML = `
      <header>
        <the-toolbar></the-toolbar>
        <loading-indicator></loading-indicator>
      </header>
      <div class="content-wrapper">
        <div class="content">
          <router-view></router-view>
        </div>
      </div>
    `;
    }
    get #isPlayerCreated() {
        return !!this.#playerEl;
    }
    #loadUserData() {
        console.log('loadUserData');
        return profileStore.loadUser()
            .then(() => {
            if (player.currentTrack) {
                this.#createPlayer();
            }
        });
    }
    get #playerEl() {
        return this.shadowRoot.querySelector('w-player');
    }
    #processPlayerState() {
        if (profileStore.profile.settings.canSaveActiveTrackState) {
            player.loadTrackStatus();
        }
    }
}
window.customElements.define(TheApp.tag, TheApp);
